import { FormikHelpers } from "formik";

import { useAuth } from "@vahak/core/dist/components/auth/useAuth";

import { LoginFormFieldsTypes, loginFormFieldNames } from "../../common/contant";
import { LoginEventTracker, trackGetOtpClicked, trackOtpSubmitted } from "./loginAuthAnalytics";
import { LoginFormAuthResult } from "../loginFormAuth.types";

export function setOtpFieldError(helpers: FormikHelpers<LoginFormFieldsTypes>, message: string) {
    helpers.setFieldError(loginFormFieldNames.otp, message);
    helpers.setFieldTouched(loginFormFieldNames.otp, true, false);
}

export function isRegisteredUser(status: LoginFormAuthResult): boolean {
    return Boolean(status.companyId);
}

interface PhoneStepSubmitParams {
    phoneNumber: string | number;
    whatsappUpdatesEnabled: boolean;
    setPhoneNum?: (phone: string | number) => void;
    onSubmitPhoneNum: ReturnType<typeof useAuth>["onSubmitPhoneNum"];
    handleEventTracking: LoginEventTracker;
    onPhoneVerified: () => void;
}

export async function submitPhoneStep({
    phoneNumber,
    whatsappUpdatesEnabled,
    setPhoneNum,
    onSubmitPhoneNum,
    handleEventTracking,
    onPhoneVerified
}: PhoneStepSubmitParams) {
    setPhoneNum?.(phoneNumber);
    await onSubmitPhoneNum();
    trackGetOtpClicked(handleEventTracking, whatsappUpdatesEnabled);
    onPhoneVerified();
}

interface OtpStepSubmitParams {
    phoneNumber: string | number;
    otp: string;
    setShouldPreventLayoutSwitch?: (value: boolean) => void;
    onSubmitOtp: ReturnType<typeof useAuth>["onSubmitOtp"];
    handleEventTracking: LoginEventTracker;
    onRegisteredUser: (status: LoginFormAuthResult) => Promise<void>;
    onNewUser: (status: LoginFormAuthResult) => Promise<void>;
    onInvalidOtp: () => void;
    guardRef?: { current: boolean };
}

export async function submitOtpStep({
    phoneNumber,
    otp,
    setShouldPreventLayoutSwitch,
    onSubmitOtp,
    handleEventTracking,
    onRegisteredUser,
    onNewUser,
    onInvalidOtp,
    guardRef
}: OtpStepSubmitParams) {
    if (guardRef?.current) {
        return;
    }

    if (guardRef) {
        guardRef.current = true;
    }

    try {
        setShouldPreventLayoutSwitch?.(true);
        const status = await onSubmitOtp({ phoneNum: phoneNumber, otp: Number(otp) });
        trackOtpSubmitted(handleEventTracking);

        if (!status) {
            onInvalidOtp();
            return;
        }

        const authResult = status as LoginFormAuthResult;

        if (isRegisteredUser(authResult)) {
            await onRegisteredUser(authResult);
            return;
        }

        await onNewUser(authResult);
    } finally {
        if (guardRef) {
            guardRef.current = false;
        }
    }
}
